.specification-dimensions-simple-field__container {
  & .ant-select-selector {
    padding: 8px 16px !important;
  }

  & .ant-select-single {
    height: unset !important;
  }
}

// Taken from text-input__label
.specification-dimensions-simple-field__container .specification-dimensions-simple-field__label {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;

  white-space: nowrap;
}

// Taken from text-input__description
.specification-dimensions-simple-field__container .specification-dimensions-simple-field__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}
